export interface RobotsBlockedAgent {
  agent: string;
  assistant?: string;
  all_bots: boolean;
  rules: string[];
}

/** Crawlers of the 10 tracked AI assistants that the site's robots.txt
 *  disallows from the whole site. Renders nothing when there are none. */
export default function RobotsBlockedAgents({ agents }: { agents?: RobotsBlockedAgent[] | null }) {
  if (!agents || agents.length === 0) return null;
  const allBots = agents.some((a) => a.all_bots);
  const named = agents.filter((a) => !a.all_bots).length;
  return (
    <div className="mb-3 p-3 bg-rose-50 border border-rose-200 rounded text-xs text-rose-900">
      <div className="font-semibold mb-2">
        robots.txt blocks {allBots ? 'all bots' : `${named} AI crawler${named === 1 ? '' : 's'}`} from the site
        {allBots && named > 0 ? ` (plus ${named} named AI crawler${named === 1 ? '' : 's'})` : ''}
      </div>
      <div className="flex flex-wrap gap-1.5">
        {agents.map((a) => (
          <span
            key={a.agent}
            title={a.rules.join('\n')}
            className="px-2 py-0.5 rounded border bg-white border-rose-200"
          >
            <span className="font-mono">{a.all_bots ? '*' : a.agent}</span>
            {a.assistant && <span className="text-rose-600"> · {a.assistant}</span>}
          </span>
        ))}
      </div>
    </div>
  );
}
